/**
 * Which build of the app is running, as `vite.config.ts` baked it in.
 *
 * Shown at the foot of the sidebar so a shop reporting a problem can read out exactly what they
 * are on, and so whoever deployed can see at a glance that the new build has reached them.
 */
declare const __APP_VERSION__: string;
declare const __APP_COMMIT__: string;

export const APP_VERSION: string = __APP_VERSION__;
export const APP_COMMIT: string = __APP_COMMIT__;

/** `v0.1.0 · 3e4767f`, or `v0.1.0` for a build that was not told its commit. */
export function appVersionLabel(version = APP_VERSION, commit = APP_COMMIT): string {
  return commit ? `v${version} · ${commit}` : `v${version}`;
}
